import { useMemo } from 'react';
import { useAuth } from 'context/AuthProvider';
import {
  formatCurrencyAmount,
  currencySymbolForCode,
  formatCompactCurrencyAmount,
  formatOctroStake,
  formatGroupedAmount,
} from 'lib/currency-format';

export function useCurrency() {
  const { user } = useAuth();

  return useMemo(() => {
    const code = user?.currency ?? null;
    const symbol = currencySymbolForCode(code, user?.currencySymbol);
    return {
      symbol,
      code,
      format: (amount: number, options?: Intl.NumberFormatOptions) =>
        formatCurrencyAmount(symbol, amount, code, options),
      formatCompact: (amount: number) => formatCompactCurrencyAmount(amount),
      formatStake: (amount: number) => formatOctroStake(amount),
      formatGrouped: (amount: number) => formatGroupedAmount(amount, code),
    };
  }, [user?.currencySymbol, user?.currency]);
}
